import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.tradingTransfer
)

export const selectIsTransferModalOpen = createSelector(
    baseSelector,
    (state) => state.isTransferBonusesModalOpen
)

export const selectOnTransfer = createSelector(
    baseSelector,
    (state) => state.onTransfer
)
